<sidenav
    class="pt-4"
    role="navigation"
    [orientation]="orientation()"
    data-testid="t-oc-sidenav-sidenav-1752672977568-1"
>
    <!-- Inner -->
    <div
        class="sidenav-inner"
        [ngClass]="{ '': orientation() !== 'horizontal' }"
        data-testid="t-oc-sidenav-div-1752672977568-1"
    >
        <sidenav-router-link
            icon="oc-general-home"
            (click)="navigateTo('mwsp/home')"
            [active]="isMenuActive('/mwsp/home')"
            data-testid="t-oc-sidenav-sidenav-router-link-1752672977568-1"
        >
            {{ 'mws.start' | i18n }}
        </sidenav-router-link>

        @if (
            env.applicationName === 'OCMWSP' &&
            coreService.checkAbility('execute', 'ui.supplier.navigation') &&
            coreService.checkModuleAbility('execute', 'module.supplier')
        ) {
            <sidenav-router-link
                icon="oc-supplier"
                (click)="navigateTo('mwsp/supplier/overview')"
                [active]="isMenuActive('/mwsp/supplier')"
                data-testid="t-oc-sidenav-sidenav-router-link-1752672977568-2"
            >
                {{ 'mws.supplier' | i18n }}</sidenav-router-link
            >
        }
        @if (
            env.applicationName === 'OCMWSP' &&
            (!coreService.checkAbility('execute', 'ui.supplier.navigation') || !coreService.checkModuleAbility('execute', 'module.supplier'))
        ) {
            <sidenav-router-link
                icon="oc-supplier"
                [disabled]="true"
                linkClass="unactive"
                data-testid="t-oc-sidenav-sidenav-router-link-1752672977568-3"
            >
                {{ 'mws.supplier' | i18n }}
            </sidenav-router-link>
        }

        @if (
            env.applicationName === 'OCMWSP' &&
            coreService.checkAbility('execute', 'ui.purchaseitem.navigation') &&
            coreService.checkModuleAbility('execute', 'module.purchasearticle')
        ) {
            <!-- route="/mwsp/purchaseitem/overview" -->
            <sidenav-router-link
                icon="oc-articles"
                (click)="navigateTo('mwsp/purchaseitem/overview')"
                [active]="isMenuActive('/mwsp/purchaseitem')"
                data-testid="t-oc-sidenav-sidenav-router-link-1752672977568-4"
            >
                {{ 'mws.purchaseitems' | i18n }}
            </sidenav-router-link>
        }
        @if (
            env.applicationName === 'OCMWSP' &&
            (!coreService.checkAbility('execute', 'ui.purchaseitem.navigation') || !coreService.checkModuleAbility('execute', 'module.purchasearticle'))
        ) {
            <sidenav-router-link
                icon="oc-articles"
                [disabled]="true"
                linkClass="unactive"
                data-testid="t-oc-sidenav-sidenav-router-link-1752672977568-5"
            >
                {{ 'mws.purchaseitems' | i18n }}
            </sidenav-router-link>
        }

        <!--       environmentService.userCostcenter && environmentService.userCostcenter.usercostcenters && environmentService.userCostcenter.usercostcenters.length>0 && coreService.checkAbility('execute', 'ui.recipe.navigation')-->
        @if (
            (env.applicationName === 'OCMWSP' &&
                environmentService.userCostcenter?.usercostcenters?.length > 0 &&
                coreService.checkModuleAbility('execute', 'module.recipe') &&
                coreService.checkAbility('execute', 'ui.recipe.navigation')) ||
            env.applicationName !== 'OCMWSP'
        ) {
            <sidenav-router-link
                icon="oc-recipe"
                (click)="navigateTo('mwsp/recipe/overview')"
                [active]="isMenuActive('/mwsp/recipe')"
                data-testid="t-oc-sidenav-sidenav-router-link-1752672977568-6"
            >
                {{ 'mws.recipe' | i18n }}
            </sidenav-router-link>
        } @else {
            <sidenav-router-link
                icon="oc-recipe"
                [disabled]="true"
                linkClass="unactive"
                data-testid="t-oc-sidenav-sidenav-router-link-1752672977568-7"
            >
                {{ 'mws.recipe' | i18n }}
            </sidenav-router-link>
        }
        <!--       !environmentService.userCostcenter || !environmentService.userCostcenter.usercostcenters || environmentService.userCostcenter.usercostcenters.length===0 || !coreService.checkAbility('execute', 'ui.recipe.navigation')-->

        <!-- route="/mwsp/purchase/overview" [active]="isActive('/mwsp/purchase/overview')" -->
        <!--        linkClass="unactive"-->
        @if (
            env.applicationName === 'OCMWSP' &&
            coreService.checkAbility('execute', 'ui.purchase.navigation') &&
            coreService.checkModuleAbility('execute', 'module.purchasing') &&
            environmentService.userCostcenter?.usercostcenters?.length > 0
        ) {
            <sidenav-router-link
                icon="oc-shopping-cart"
                (click)="navigateTo('mwsp/purchase/overview')"
                [active]="isMenuActive('/mwsp/purchase')"
                data-testid="t-oc-sidenav-sidenav-router-link-1752672977568-8"
            >
                {{ 'mws.purchase' | i18n }}
            </sidenav-router-link>
        } @else {
            @if (env.applicationName === 'OCMWSP') {
                <sidenav-router-link
                    icon="oc-shopping-cart"
                    [disabled]="true"
                    linkClass="unactive"
                    data-testid="t-oc-sidenav-sidenav-router-link-1752672977568-9"
                >
                    {{ 'mws.purchase' | i18n }}
                </sidenav-router-link>
            }
        }

        @if (
            env.applicationName === 'OCMWSP' &&
            coreService.checkAbility('execute', 'ui.goodsreceipt.navigation') &&
            coreService.checkModuleAbility('execute', 'module.goodsreceive') &&
            environmentService.userCostcenter?.usercostcenters?.length > 0
        ) {
            <sidenav-router-link
                icon="oc-goods-recipe"
                (click)="navigateTo('mwsp/goodsreceipt')"
                [active]="isMenuActive('/mwsp/goodsreceipt')"
                data-testid="t-oc-sidenav-sidenav-router-link-1752672977568-10"
            >
                {{ 'mws.goodsreceipt' | i18n }}
            </sidenav-router-link>
        } @else {
            @if (env.applicationName === 'OCMWSP') {
                <sidenav-router-link
                    icon="oc-goods-recipe"
                    [disabled]="true"
                    linkClass="unactive"
                    data-testid="t-oc-sidenav-sidenav-router-link-1752672977568-11"
                >
                    {{ 'mws.goodsreceipt' | i18n }}
                </sidenav-router-link>
            }
        }

        @if (env.applicationName === 'OCMWSP') {
            @if (coreService.checkAbility('execute', 'ui.invoiceverification.navigation')) {
                <sidenav-router-link
                    icon="oc-statistics"
                    (click)="openInvoiceVerification()"
                >
                    {{ 'mws.invoiceverification' | i18n }}
                </sidenav-router-link>
            } @else {
                <sidenav-router-link
                    icon="oc-pay"
                    [disabled]="true"
                    linkClass="unactive"
                >
                    {{ 'mws.invoiceverification' | i18n }}
                </sidenav-router-link>
            }
        }

        @if (
            env.applicationName === 'OCMWSP' &&
            coreService.checkAbility('execute', 'ui.warehouse.navigation') &&
            coreService.checkModuleAbility('execute', 'module.warehouse') &&
            environmentService.userCostcenter?.usercostcenters?.length > 0
        ) {
            <sidenav-router-link
                icon="oc-storage"
                (click)="navigateTo('mwsp/warehouses')"
                [active]="isMenuActive('/mwsp/warehouses')"
                data-testid="t-oc-sidenav-sidenav-router-link-1752672977568-14"
            >
                {{ 'mws.storage' | i18n }} / {{ 'mws.inventory' | i18n }}
            </sidenav-router-link>
        } @else {
            @if (env.applicationName === 'OCMWSP') {
                <sidenav-router-link
                    icon="oc-storage"
                    [disabled]="true"
                    linkClass="unactive"
                    data-testid="t-oc-sidenav-sidenav-router-link-1752672977568-15"
                >
                    {{ 'mws.storage' | i18n }} / {{ 'mws.inventory' | i18n }}
                </sidenav-router-link>
            }
        }

        <!-- TODO: Lizenzprüfung module.??????? -->
        @if (env.applicationName === 'OCMWSP' && coreService.checkAbility('execute', 'ui.costcenter.navigation')) {
            <sidenav-router-link
                icon="oc-pay-euro"
                (click)="navigateTo('mwsp/costcenter/overview')"
                [active]="isActive('/mwsp/costcenter')"
                data-testid="t-oc-sidenav-sidenav-router-link-1752672977568-16"
            >
                {{ 'mws.costcenter' | i18n }}
            </sidenav-router-link>
        }
        <!-- -->

        @if (env.applicationName === 'OCMWSP') {
            @if (coreService.checkAbility('execute', 'ui.statistic.navigation')) {
                <sidenav-router-link
                    icon="oc-statistics"
                    route="/mwsp/statistic/overview"
                >
                    {{ 'mws.statistics' | i18n }}
                </sidenav-router-link>
            } @else {
                <sidenav-router-link
                    icon="oc-statistics"
                    [disabled]="true"
                    linkClass="unactive"
                >
                    {{ 'mws.statistics' | i18n }}
                </sidenav-router-link>
            }
        }

        <!-- TODO: Lizenzprüfung module.??????? -->
        @if (coreService.checkAbility('execute', 'ui.basedata.navigation')) {
            <sidenav-router-link
                icon="oc-basedata"
                (click)="navigateTo('mwsp/basedata/overview')"
                [active]="isMenuActive('/mwsp/basedata')"
                data-testid="t-oc-sidenav-sidenav-router-link-1752672977568-18"
            >
                {{ 'mws.basedata' | i18n }}
            </sidenav-router-link>
        }

        <!-- KOCHBUCH -->
        <!--        *ngIf="environmentService.developmentVersion && env.applicationName === 'OCMWSP' && coreService.checkAbility('execute', 'ui.cookbook.navigation')">-->
        <!--        <div class="sidenav-item d-block"-->
        <!--             *ngIf="environmentService.developmentVersion && env.applicationName === 'OCMWSP' && coreService.checkAbility('execute', 'ui.cookbook.navigation')">-->
        <!--            <a class="sidenav-link" href="/mws/cookbook" target="_blank">-->
        <!--                <i class="sidenav-icon oc-basedata" ng-reflect-klass="sidenav-icon" ng-reflect-ng-class="oc-cookbook"></i>-->
        <!--                <div>{{ 'mws.cookbook' | i18n }}</div>-->
        <!--            </a>-->
        <!--        </div>-->
    </div>
</sidenav>
